module.exports = __webpack_public_path__ + "static/media/unlocked-new-badge.cf556d9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/unlocked-new-badge.mp3
// module id = 3hyA
// module chunks = 0